var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "title-box" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "title-content", style: _vm.titleStyle }, [
      _vm._v(_vm._s(_vm.title)),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "title-operation-box" }, [_vm._t("statistic")], 2),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-span" }, [_c("span")])
  },
]
render._withStripped = true

export { render, staticRenderFns }